/**
 * CONTRACT.md §2.11 — the timeline.
 *
 * `<ol>` / `<li>`: the items are in order and the order is the meaning.
 *
 * `.tl__date` is **plain sans**, not `.date` (§3: "P6 — it is a label here, not
 * tabular data. Use `.date` for a date in a table cell"). So `date` here is a
 * string a page has already formatted through `useFormat` — the timeline's
 * dates are phrases like "Wed 26 Aug" and "Thu 3 Sep · 08:00 EDT" rather than
 * one instant, and there is no date style that produces those.
 *
 * §3 removed `--jade`, `--steel` and `--bad`: `need` is the only modifier.
 */

import type { ReactNode } from 'react'

import { cx, type Common } from './common.js'

export type TimelineProps = Common & { readonly children: ReactNode }

export function Timeline({ children, ...common }: TimelineProps) {
  return (
    <ol className="tl" {...common}>
      {children}
    </ol>
  )
}

export type TimelineItemProps = Common & {
  /** `.tl__item--need` — an ochre dot: the next move is yours. */
  readonly need?: boolean | undefined
  readonly date: ReactNode
  readonly title: ReactNode
  readonly note?: ReactNode | undefined
}

export function TimelineItem({ need, date, title, note, ...common }: TimelineItemProps) {
  return (
    <li className={cx('tl__item', need && 'tl__item--need')} {...common}>
      <div className="tl__date">{date}</div>
      <div className="tl__title">{title}</div>
      {note === undefined ? null : <div className="tl__note">{note}</div>}
    </li>
  )
}
